export function addPendingMembershipsToOrgTree(organizations, organizationMembershipCountMap) {
    return organizations.map((organization) => {
        var _a, _b;
        const orgTreeItem = Object.assign(Object.assign({}, organization), { pendingMemberCount: (_b = (_a = organizationMembershipCountMap[organization.id.split('_')[0]]) === null || _a === void 0 ? void 0 : _a.pendingMemberships) !== null && _b !== void 0 ? _b : 0 });
        if (organization.children) {
            orgTreeItem.children = addPendingMembershipsToOrgTree(organization.children, organizationMembershipCountMap);
        }
        return orgTreeItem;
    });
}
